/**
 * Utility functions for searching vehicles by different criteria
 */

/**
 * Search for a vehicle in the data array using the specified search type and value
 * @param {Array} data - Array of vehicle objects
 * @param {string} searchType - Type of search ('id', 'stock', or 'vin')
 * @param {string} searchValue - Value to search for
 * @returns {Object} Vehicle object or {error: string}
 */
export const searchVehicle = (data, searchType, searchValue) => {
    if (!searchValue || !searchValue.trim()) {
        return { error: "Search value is required" };
    }

    let match;

    switch (searchType) {
        case 'id':
            match = data.find(vehicle => vehicle.id === parseInt(searchValue));
            break;
        case 'stock':
            match = data.find(vehicle =>
                vehicle.stock.toLowerCase() === searchValue.toLowerCase()
            );
            break;
        case 'vin':
            match = data.find(vehicle =>
                vehicle.vin.toLowerCase() === searchValue.toLowerCase()
            );
            break;
        default:
            return { error: "Invalid search type" };
    }

    if (!match) {
        return { error: "Vehicle not found" };
    }

    return match;
};
